import React from 'react';
import ExternalSvg from 'components/ExternalSvg';
import { AshaIconProps } from '../types';

const AshaSoupsAndSalads = ({ width = '24px', height = '24px' }: AshaIconProps) => (
  <ExternalSvg customer="asha" iconName="ashaSoupsAndSalads" width={width} height={height} />
);

export default AshaSoupsAndSalads;
